
OutcomeTypes =
    job:
        label:"Job Placement Types"
        column: 'job_type'
    education:
        label: "Education Placement Types"
        column: 'institution_type'
    certificate:
        label: "Certificate Types"
        column: 'certificate_name'

outcomeTypeStates = ($stateProvider, TagUrl) ->
    'ngInject'

    url = new TagUrl()
        .addTagTypes(['program', 'location', 'participant'])
        .setTagDefault('affiliation', 'all')
        .addExtraParam('page', {type: 'int', value: 1, squash: true})
        .addExtraParam('sort', 'name')

    programUrl = new TagUrl()
        .addTagTypes(['participant'])
        .setTagDefault('affiliation', 'all')
        .addExtraParam('page', {type: 'int', value: 1, squash: true})
        .addExtraParam('sort', 'name')

    $stateProvider.state 'reports.outcomeType',
        url: url.buildUrl('/:outcome-types')
        reloadOnSearch: false
        data:
            tagUrl: url
            outcomes: OutcomeTypes
        params: url.params
        abstract: true
        templateUrl: 'reports/outcomeTypes/base'
        controller: 'OutcomeTypeReportBaseController'
        controllerAs: '$ctrl'
        resolve:
            program: () -> null

    $stateProvider.state 'reports.outcomeType.totals',
        url: '/{value}'
        reloadOnSearch: false
        params:
            value: squash: true
        templateUrl: 'reports/outcomeTypes/totals'
        controller: 'OutcomeTypeTotalsReportController'
        controllerAs: '$ctrl'
        resolve:
            config: resolveGlobalConfig

    $stateProvider.state 'program.reports.outcomeType',
        url: programUrl.buildUrl('/:outcome-types')
        abstract: true
        params: programUrl.params
        reloadOnSearch: false
        data:
            tagUrl: programUrl
            outcomes: OutcomeTypes
            tagRefreshInject: ["program"]
        templateUrl: 'reports/outcomeTypes/base'
        controller: 'OutcomeTypeReportBaseController'
        controllerAs: '$ctrl'

    $stateProvider.state 'program.reports.outcomeType.totals',
        url: '/{value}'
        reloadOnSearch: false
        params:
            value: squash: true
        templateUrl: 'reports/outcomeTypes/totals'
        controller: 'OutcomeTypeTotalsReportController'
        controllerAs: '$ctrl'
        resolve: config: resolveGlobalConfig


resolveGlobalConfig = ($stateParams, $state, program, OutcomeTypeReportService) ->
    'ngInject'

    program_id = if program then program.id else undefined

    return OutcomeTypeReportService
        .getGlobalConfig($stateParams.outcome, $stateParams.value, program_id)
        .catch () -> $state.go('.', {outcome: 'job'})



class OutcomeTypeReportService

    ### @ngInject ###
    constructor: ($http, $timeout, ApiUrl) ->
        @http = $http
        @timeout = $timeout
        @ApiUrl = ApiUrl
        @url = ApiUrl.partial('reports', 'outcome-types')

    getGlobalConfig: (outcome, value, program_id) ->
        url = @url("#{outcome}-types", 'config')
        params =
            value: value
            program_id: program_id
        return @http.get(url, params: params).then (result) -> result.data

    getGlobalTotals: (outcome, params) ->
        url = @url("#{outcome}-types")
        return @http.get(url, params: params)
            .then (result) -> result.data

    createDebounce: (callback) ->
        timeoutPromise = null
        return () =>
            @timeout.cancel(timeoutPromise)
            timeoutPromise = @timeout callback, 100


class OutcomeTypeReportBaseController

    ### @ngInject ###
    constructor: ($scope, program, TagRefreshService) ->
        @refresh = TagRefreshService.bindTagRefreshToScope($scope);
        @program = program

class OutcomeTypeTotalsReportController

    ### @ngInject ###
    constructor: ($state, $stateParams, $scope, config, program, OutcomeTypeReportService) ->

        @state = $state
        @service = OutcomeTypeReportService
        @config = config

        @program = program
        @value = $stateParams.value or undefined
        @outcome = $stateParams.outcome
        @outcomeLabel = OutcomeTypes[@outcome]
        $state.go('.', outcome: 'job')  if not @outcomeLabel

        @sort = $stateParams.sort or @config.name
        @page = $stateParams.page or 1
        @pager = null

        @link = @getLink()

        $scope.$on 'tagRefresh', @tagChanged
        $scope.$watch '$ctrl.pager.page', @turnPage

        @triggerLoad = OutcomeTypeReportService.createDebounce @loadData
        $scope.triggerRefresh()

    getLink: () ->
        if not @value
            return '.'

        else if not @program
            return 'program.reports.outcomeType.totals'

        else if @program
            return 'student.overview'

    loadData: () =>
        @loading = true
        params = angular.extend {}, @tags,
            program_id: @program and @program.id
            sort: @sort
            value: @value
            page: if @value then @page else 1

        @state.go '.', params, replace: true

        @service.getGlobalTotals(@outcome, params).then (data) =>
            @loading = false
            @items = data.items
            @pager = data.pager
            @total = data.total

    tagChanged: (event, tags) =>
        if not @tags
            @tags = tags
            @triggerLoad()
            return

        if not angular.equals(tags, @tags)
            @tags = tags
            @turnPage(1)
            @triggerLoad()

    turnPage: (page) =>
        if not page or page == @page then return
        @page = page
        @triggerLoad()

    onSortChange: () ->
        @page = 1
        @triggerLoad()


module.config outcomeTypeStates
module.service 'OutcomeTypeReportService', OutcomeTypeReportService
module.controller 'OutcomeTypeTotalsReportController', OutcomeTypeTotalsReportController
module.controller 'OutcomeTypeReportBaseController', OutcomeTypeReportBaseController
